import { useEffect, useState } from 'react'

import { getBreakpointMediaQuery, isBelowBreakpoint } from './isBelowBreakpoint'
import type { BreakpointSize } from './types'

/**
 * Hook to detect when the viewport is at or below a given Tailwind breakpoint.
 * Uses CSS variables defined by Tailwind v4 (--breakpoint-sm, --breakpoint-md, …).
 * @param breakpointSize - The breakpoint at which the layout switches to block view ('sm' | 'md' | 'lg' | 'xl' | '2xl')
 * @returns Boolean indicating if viewport is at or below the given breakpoint
 */
export const useResponsive = (breakpointSize: BreakpointSize = 'md') => {
  const [isBelow, setIsBelow] = useState(() => isBelowBreakpoint(breakpointSize))

  useEffect(() => {
    const mediaQuery = getBreakpointMediaQuery(breakpointSize)
    const handler = (e: MediaQueryListEvent) => setIsBelow(e.matches)
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [breakpointSize])

  return isBelow
}
